import {fetchConToken} from '../helpers/fetch'

const logout = async () => {
  const resp = await fetchConToken('auth/logout', {}, 'POST')

  const body = await resp.json()

  return body
}

export {logout}
